import { createContext, useContext, useState, useCallback } from "react";

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

export const SnackbarProvider = ({ children }) => {
    const [snack, setSnack] = useState({
        open: false,
        message: "",
        type: "success", // "success" | "error" | "etc"
    });

    const showSnackbar = useCallback((message, type = "success") => {
        setSnack({ open: true, message, type });
    }, []);

    const hideSnackbar = useCallback(() => {
        setSnack((prev) => ({ ...prev, open: false }));
    }, []);

    return (
        <SnackbarContext.Provider value={{ snack, showSnackbar, hideSnackbar }}>
        {children}
        </SnackbarContext.Provider>
    );
};
